import {
  Button,
  Group,
  LoadingOverlay,
  Stack,
  Text,
  TextInput,
} from "@mantine/core";
import { useState } from "react";
import PhoneNumberInput from "../../../components/Selectors/PhoneNumberInput";
import { updateProfile, updateSelf } from "../../../api/UserAPI";
import { useProfileStore } from "../../../stores/UserStore";
import { useLanguage } from "../../../stores/LanguageStore";

const CompleteProfile = ({ onFinish, inputSize = "lg", inModal }) => {
  const lang = useLanguage((s) => s.language);
  const profile = useProfileStore((s) => s.profile);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);

    setLoading(true);
    updateProfile(null, { show_onboarding: false, timezone: Intl.DateTimeFormat().resolvedOptions().timeZone, ...data })
      .then(() => {
        if (inModal) {
          updateSelf();
          onFinish?.();
          setLoading(false);
        } else {
          updateSelf()
            .then(onFinish)
            .finally(() => setLoading(false));
        }
      })
      .catch(() => setLoading(false));
  };

  return (
    <Stack component={"form"} p={"md"} gap={"md"} onSubmit={handleSubmit}>
      <LoadingOverlay visible={loading} />
      {inModal && (
        <>
          <Text ta={"center"} fz={32} mb={-16}>
            🚀
          </Text>
          <Text fz={32} ta={"center"} fw={800} c={"primary"} lh={1.1}>
            {lang.new_ui_onboarding.title}
          </Text>

          <Text size="lg" ta={"center"}>
            {lang.profile.onboarding_text}
          </Text>
        </>
      )}

      <Group>
        <TextInput
          flex={1}
          label={lang.signup.first_name}
          defaultValue={profile.first_name}
          name="first_name"
          size={inputSize}
          required
        />
        <TextInput
          flex={1}
          label={lang.signup.last_name}
          defaultValue={profile.last_name}
          name="last_name"
          size={inputSize}
          required
        />
      </Group>

      <TextInput
        flex={1}
        label={lang.profile.company}
        placeholder={lang.profile.company_desc}
        defaultValue={profile.company}
        name="company"
        size={inputSize}
        required={!inModal}
      />
      <TextInput
        flex={1}
        label={lang.profile.job_title}
        placeholder={lang.profile.job_title_desc}
        defaultValue={profile.job_title}
        name="job_title"
        size={inputSize}
        required={!inModal}
      />
      <PhoneNumberInput
        defaultCountry={profile?.mobile_phone_country || "FR"}
        defaultValue={profile?.mobile_phone}
        name={"mobile_phone"}
        label={lang.profile.mobile_phone}
        flex={1}
        w={"100%"}
        size={inputSize}
        required={!inModal}
      />

      <Group justify="center" mt={"md"}>
        <Button type="submit" size={inputSize}>
          {lang.global.finish}
        </Button>
      </Group>
    </Stack>
  );
};

export default CompleteProfile;
